/** Czas — wszędzie UTC, strefa użytkownika tylko przy prezentacji i planowaniu powiadomień. */

export const DAY_MS = 86_400_000;

/** Pełne dni od `now` do `target`; wartość ujemna = termin minął. */
export function daysUntil(target: Date, now: Date = new Date()): number {
  return Math.floor((target.getTime() - now.getTime()) / DAY_MS);
}

export function addDays(date: Date, days: number): Date {
  return new Date(date.getTime() + days * DAY_MS);
}

/** Początek dnia UTC — bucket deduplikacji Cue po terminie (CUE_ENGINE.md §4). */
export function startOfUtcDay(date: Date): Date {
  return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
}

export function isoDate(date: Date): string {
  return startOfUtcDay(date).toISOString().slice(0, 10);
}

/** Numer tygodnia ISO-8601 w formacie `2026-W34` — klucz agregatów marketingowych (§32). */
export function isoWeek(date: Date): string {
  const d = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
  // Czwartek tego samego tygodnia wyznacza rok wg ISO-8601.
  const dayNumber = (d.getUTCDay() + 6) % 7;
  d.setUTCDate(d.getUTCDate() - dayNumber + 3);
  const firstThursday = new Date(Date.UTC(d.getUTCFullYear(), 0, 4));
  const firstDayNumber = (firstThursday.getUTCDay() + 6) % 7;
  firstThursday.setUTCDate(firstThursday.getUTCDate() - firstDayNumber + 3);
  const week = 1 + Math.round((d.getTime() - firstThursday.getTime()) / (7 * DAY_MS));
  return `${d.getUTCFullYear()}-W${String(week).padStart(2, "0")}`;
}
